<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Cash Note Name"
                  v-model="cashNote.name"
                  type="text"
                  :rules="rules.cashNoteNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="value"
                  label="Cash Note Value"	
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  v-model="cashNote.value"
                  :rules="rules.cashNoteValueRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="currencyList"
                  v-model="cashNote.currencyCode"
                  label="Choose Currency"
                  item-text="name"
                  item-value="code"
                  menu-props="auto"
                  :rules="rules.currencyCodeRules"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Cash Note Description"
                  v-model="cashNote.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="cashNote.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="cashNote.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="cashNote.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="cashNote.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="cashNote.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="cashNote.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="cashNote.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { cashNoteService } from "../../services/cash-note-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { CashNote } from "../../models/model";
import { CashNoteFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import { currencyService } from "../../services/currency-service";

export default {
  name: "CashNoteDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    saveLoading: false,
    breadcrumbs: [
      {
        text: "Cash Note",
        disabled: false,
        to: "cash-notes",
      },
      {
        text: "Cash Notes Detail",
        disabled: true,
      },
    ],
    cashNote: new CashNote(),
    oldCashNote: new CashNote(),
    rules: new CashNoteFormRules(),
    statusFlag: true,
    responseError: "",
    updatedDate: "",
    createdDate: "",
    currencyList: [],
  }),
  created() {
    this.getActiveCurrency();
    const id = this.$route.params.id;
    if (id == "new") {
      // new cash note
    } else {
      this.getCashNoteDetail(id);
    }
  },
  methods: {
    getActiveCurrency() {
      currencyService
        .getCurrencyByStatus("ACTIVE")
        .then((res) => {
          this.currencyList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCashNoteDetail(id) {
      cashNoteService
        .getCashNoteDetail(id)
        .then((res) => {
          this.cashNote = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.cashNote.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.cashNote.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldCashNote = Object.assign({}, res.data);
          this.statusFlag = this.cashNote.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.cashNote.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        let cashNoteObj = {
          id: this.cashNote.id ? this.cashNote.id : "",
          name: this.cashNote.name,
          value: this.cashNote.value,
          currencyCode: this.cashNote.currencyCode,
          description: this.cashNote.description,
          status: this.cashNote.status,
        };
        cashNoteService
          .saveCashNote(cashNoteObj)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.cashNote.id) {
        this.cashNote = new CashNote();
        this.statusFlag = true;
      } else {
        this.cashNote = Object.assign({}, this.oldCashNote);
        this.statusFlag = this.cashNote.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/cash-notes");
    },
  },
};
</script>
